import { AppStrings } from "./constants/AppStrings";

export const PLAID_STATUSES = {
    VERIFIED: "verified",
    FAILED: "failed",
    ACTIVE: "active",
    PENDING_REVIEW: "pending_review",
    NOT_VERIFIED: "not_verified"
}

export const determineSuspensionStatus = (user_data) => {
    if ((user_data?.suspended && user_data?.suspended === "0") || !user_data?.suspended) {
        return false
    }
    else {
        return true
    }
}

/*
    Checks if a value is truthy.
    @param {any} value - The value to check.
    @returns {boolean} - Returns true if the value is truthy, otherwise false.
*/
export const isTruthyFlag = (value) => {
    if (value === true || value === 1 || value === "1" || value === "true") return true;
    return false;
}

/*
    Handles the suspension reasons config.
    @param {array} suspensionReasonsConfig - The suspension reasons config.
    @returns {array} - The suspension reasons.
*/
export const handleSuspensionReasonsConfig = (suspensionReasonsConfig) => {
    return suspensionReasonsConfig?.map((reason) => {
        return {
            value: reason,
            label: reason
        }
    });
}

/**
 * Turns snake_case API values into title-style labels, e.g. "stuck_redemptions" → "Stuck Redemptions".
 * @param {string} snakeCase
 * @returns {string}
 */
export const snakeCaseToTitleLabel = (snakeCase) => {
    if (snakeCase == null || snakeCase === "") return "";
    return String(snakeCase)
        .split("_")
        .filter(Boolean)
        .map(
            (word) =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
        )
        .join(" ");
};

/*
    Handles the approval reasons config.
    @param {array} approvalReasonsConfig - The approval reasons config.
    @returns {array} - The approval reasons.
*/
export const handleWithdrawalReasonsConfig = (approvalReasonsConfig) => {
    return approvalReasonsConfig?.map((reason) => ({
        value: reason,
        label:
            AppStrings[reason.toUpperCase()] ?? snakeCaseToTitleLabel(reason),
    }));
};
